import React, { useCallback, useRef, useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useEffect } from 'react';
import { post } from '../../Auths/AuthToken';
import { Link } from 'react-router-dom';
import { DEFAULT_DATE_FORMATE, DEFAULT_LOCAL_PATH } from '../../../constents';
import CalanderHeader from './CalanderHeader';
import ReactDatePicker from 'react-datepicker';
import AddTaskPopup from './AddTaskPopup';
import {
  addDays,
  compareAsc,
  differenceInDays,
  endOfMonth,
  endOfWeek,
  formatISO,
  isWithinInterval,
  parseISO,
  startOfDay,
  startOfMonth,
} from 'date-fns';
import WeeklySchedule from './WeeklySchedule';
import { useDispatch, useSelector } from 'react-redux';
import { setCalPeriod } from '../../../redux/slices/scheduler/calendarSlice';
import {
  setGlobalAppId,
  setAppPatSerchPopup,
  setAppPopup,
  setGrpApp,
  updateSearchParams,
} from '../../../redux/slices/scheduler/appointmentSlice';
import { setSeltSerchPat } from '../../../redux/slices/patient/patientSlice';
import setUiMessage from '../../../Utilities/Tostify';
import AlertDialog from '../../../Utilities/AlertDialog';
import { useAppointmentStatus } from '../../../hooks/useAppointmentStatus';

function BigCalander() {
  const clickRef = useRef(null);
  const [allData, setAllData] = useState('');
  const [allBlockData, setAllBlockData] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(undefined);
  const [eventData, setEventData] = useState(null);
  const [locList, setLocList] = useState();
  const [facilitySetting, setFacilitySetting] = useState(null);
  const [calTime, setCalTime] = useState({
    startTime: null,
    endTime: null,
    scrliiTime: null,
  });

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { calPeriodFilter } = useSelector((store) => store.calander);
  const { appSearchPrams } = useSelector((store) => store.appointment);
  const { globalReload, defaultTimeFormat } = useSelector((store) => store.app);

  const [allResource, setAllResource] = useState(null);

  const [addTask, setAddTask] = useState(false);
  const [reload, setReload] = useState(false);
  const [weeklySchedule, setWeeklySchedule] = useState(false);

  const { isDialogOpen, checkAppState, closeDialog } = useAppointmentStatus(
    post,
    setUiMessage,
  );

  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek: () =>
      startOfWeek(new Date(), {
        weekStartsOn: facilitySetting?.facility_start_day === '1' ? 1 : 0,
      }), // Monday
    getDay,
    locales: {
      'en-US': require('date-fns/locale/en-US'),
    },
  });

  const [cancelCheck, setCancelCheck] = useState(false);
  const [rescheduleCheck, setRescheduleCheck] = useState(false);

  useEffect(() => {
    /**
     * What Is This?
     * This is to prevent a memory leak, in the off chance that you
     * teardown your interface prior to the timed method being called.
     */
    return () => {
      window.clearTimeout(clickRef?.current);
    };
  }, []);

  const onSelectEvent = useCallback((event) => {
    /**
     * Here we are waiting 250 milliseconds (use what you want) prior to firing
     * our method. Why? Because both 'click' and 'doubleClick'
     * would fire, in the event of a 'doubleClick'. By doing
     * this, the 'click' handler is overridden by the 'doubleClick'
     * action.
     */
    //if (event?.is_task === '1') return;
    window.clearTimeout(clickRef?.current);
    clickRef.current = window.setTimeout(() => {
      if (event?.is_task === '1') {
        setAddTask(true);
      } else {
        setSelectedEvent(event);
      }
      setEventData(event);
    }, 250);
  }, []);

  const onDoubleClickEvent = useCallback(
    (calEvent) => {
      if (calEvent?.is_task === '1') return;
      window.clearTimeout(clickRef?.current);
      clickRef.current = window.setTimeout(() => {
        checkAppState(calEvent?.appData?.appId, () => {
          dispatch(setGrpApp(false));
          dispatch(setAppPopup(true));
          dispatch(setGlobalAppId(calEvent?.appData?.appId));
        });
      }, 250);
    },
    [dispatch, checkAppState],
  );

  useEffect(() => {
    (async () => {
      const response = await post('api/auth/appCalanderData', {
        resourceId: appSearchPrams.allProviders,
        locationId: appSearchPrams.clinicLocation,
        start: format(new Date(calPeriodFilter.startDate), 'yyyy-MM-dd'),
        end: format(new Date(calPeriodFilter.endDate), 'yyyy-MM-dd'),
        staffUserId: user?.id,
      });
      if (response.status === 200) {
        setAllData(response?.data);
        setAllBlockData(response?.data?.eventsClose || []);
        setLocList(response?.data?.locList);
        setAllResource(response?.data?.allResource);
        setFacilitySetting(response?.data?.facilitySetting || []);
        setCalTime({
          startTime: response?.data?.facilitySetting?.facility_first_hour,
          endTime: response?.data?.facilitySetting?.facility_last_hour,
          scrliiTime: response?.data?.facilitySetting?.facility_scroll_hour,
        });
      }
    })();
  }, [calPeriodFilter, appSearchPrams, globalReload, user, reload]);

  const onRangeChange = useCallback(
    (range, view) => {
      if (view) {
        if (range.length === 1 && calPeriodFilter.name !== 'day') {
          dispatch(
            setCalPeriod({
              name: 'day',
              startDate: formatISO(new Date(range[0])),
              endDate: formatISO(new Date(range[0])),
            }),
          );
        } else if (range.length === 7 && calPeriodFilter.name !== 'week') {
          dispatch(
            setCalPeriod({
              name: 'week',
              startDate: formatISO(
                startOfWeek(new Date(range[0]), {
                  weekStartsOn:
                    facilitySetting?.facility_start_day === '1' ? 1 : 0,
                }),
              ),
              endDate: formatISO(
                endOfWeek(new Date(range[6]), {
                  weekStartsOn:
                    facilitySetting?.facility_start_day === '1' ? 1 : 0,
                }),
              ),
            }),
          );
        } else if (
          range.length !== 1 &&
          range.length !== 7 &&
          calPeriodFilter.name !== 'month'
        ) {
          const totalDays = differenceInDays(
            new Date(range.end),
            new Date(range.start),
          );
          const safeStart = new Date(
            new Date(range.start).getFullYear(),
            new Date(range.start).getMonth(),
            new Date(range.start).getDate(),
            12,
          );
          const middleDate = addDays(safeStart, Math.floor(totalDays / 2));
          const currentMonthStart = startOfMonth(middleDate);
          const currentMonthEnd = endOfMonth(middleDate);
          dispatch(
            setCalPeriod({
              name: 'month',
              startDate: formatISO(startOfMonth(new Date(currentMonthStart))),
              endDate: formatISO(endOfMonth(new Date(currentMonthEnd))),
            }),
          );
        }
      }
    },
    [calPeriodFilter.name, dispatch, facilitySetting?.facility_start_day],
  );

  const onNavigate = (newDate, view, action) => {
    if (view === 'day') {
      dispatch(
        setCalPeriod({
          name: 'day',
          startDate: formatISO(newDate),
          endDate: formatISO(newDate),
        }),
      );
    } else if (view === 'week') {
      dispatch(
        setCalPeriod({
          name: 'week',
          startDate: formatISO(
            startOfWeek(newDate, {
              weekStartsOn: facilitySetting?.facility_start_day === '1' ? 1 : 0,
            }),
          ),
          endDate: formatISO(
            endOfWeek(newDate, {
              weekStartsOn: facilitySetting?.facility_start_day === '1' ? 1 : 0,
            }),
          ),
        }),
      );
    } else if (view === 'month') {
      dispatch(
        setCalPeriod({
          name: 'month',
          startDate: formatISO(startOfMonth(newDate)),
          endDate: formatISO(endOfMonth(newDate)),
        }),
      );
    }
  };

  const handleLocation = useCallback(
    (e) => {
      dispatch(
        updateSearchParams({
          key: 'clinicLocation',
          value: e.target.value,
        }),
      );
    },
    [dispatch],
  );
  const handleResource = useCallback(
    (e) => {
      dispatch(
        updateSearchParams({
          key: 'allProviders',
          value: e.target.value,
        }),
      );
    },
    [dispatch],
  );

  const handleTitlePpUpClose = (event) => {
    setSelectedEvent(undefined);
    setEventData(null);
  };

  const handleSelectSlot = (event) => {
    if (calPeriodFilter?.name === 'month' || event.start.getHours() >= 7) {
      dispatch(setGrpApp(false));
      dispatch(setAppPopup(true));
      dispatch(
        setSeltSerchPat({
          patId: null,
          getPatientType: null,
          getNewPatientType: null,
          patName: null,
          appDate: formatISO(new Date(event?.start)),
          appTime: formatISO(new Date(event?.end)),
        }),
      );
      dispatch(setAppPatSerchPopup(true));
    }
  };

  const TitlePpup = () => {
    return (
      <div id="overlay" onClick={(e) => handleTitlePpUpClose(e)}>
        <div className="title-popup-container" id="text">
          <div className="title-popup-head">
            <span className="title-popup-head-title">
              {eventData?.appData?.appTime}
            </span>
            <span
              className="title-popup-head-close"
              onClick={(e) => handleTitlePpUpClose(e)}
            >
              x
            </span>
          </div>
          <div className="tp-name-block">
            <div className="schToolTipTopLeftRow">
              <Link
                to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${eventData?.appData?.appPatientId}`}
              >
                <div className="schToolTipInnerRow" title="Go To Patient Chart">
                  {eventData?.appData?.patientFullName}
                  {eventData?.appData?.chartNumber
                    ? '[' + eventData?.appData?.chartNumber + ']'
                    : ''}
                </div>
              </Link>
              <div className="schToolTipInnerRow">
                {eventData?.appData?.age +
                  ', ' +
                  eventData?.appData?.gender +
                  ', ' +
                  eventData?.appData?.dob}
              </div>
            </div>
            <img
              src={eventData?.appData?.photograph}
              height="40"
              width="46"
              alt=""
            />
          </div>
          <div className="title-popup-row">
            <span>H: {eventData?.appData?.homePhoneOfPatient}</span>
            <span>M: {eventData?.appData?.mobilePhoneOfPatient}</span>
          </div>
          <div className="title-popup-row">e: {eventData?.appData?.email}</div>
          <div className="title-popup-row">{eventData?.appData?.visitType}</div>
          <div className="title-popup-row">
            {eventData?.appData?.appDate + ', ' + eventData?.appData?.appTime}
          </div>
          <div className="title-popup-row">
            P:{eventData?.appData?.provider_name}
            {', '}R:
            {eventData?.appData?.doctor_name}
          </div>
          <div className="title-popup-row">
            Status: {eventData?.appData?.status}
          </div>
          <div className="title-popup-row">
            Payment type: {eventData?.appData?.paymentType}
          </div>
          <div className="title-popup-row">
            Location: {eventData?.appData?.locationCode}
          </div>
          <div className="title-popup-row">
            Reason {eventData?.appData?.visitNote}
          </div>
        </div>
      </div>
    );
  };

  const handleChange = useCallback(
    (date) => {
      window.clearTimeout(clickRef?.current);
      clickRef.current = window.setTimeout(() => {
        dispatch(
          setCalPeriod({
            name: 'day',
            startDate: formatISO(date),
            endDate: formatISO(date),
          }),
        );
      }, 250);
    },
    [dispatch],
  );

  const dayPropGetter = useCallback(
    (date) => {
      let overrideBlock =
        allData?.overrideSetting && allData?.overrideSetting?.schedule_type;
      let overrideBlockDateStart =
        allData?.overrideSetting && allData?.overrideSetting?.start_date;
      let overrideBlockDateEnd =
        allData?.overrideSetting && allData?.overrideSetting?.end_date;
      if (
        overrideBlock === '1' &&
        overrideBlockDateStart &&
        overrideBlockDateEnd
      ) {
        const startDate = new Date(overrideBlockDateStart);
        const endDate = new Date(overrideBlockDateEnd);
        if (
          startOfDay(date) >= startOfDay(startDate) &&
          startOfDay(date) <= startOfDay(endDate)
        ) {
          return null;
        }
      }

      const providerScheduleEnd =
        allData?.providerScheduleEnd &&
        new Date(allData?.providerScheduleEnd?.end_date);
      if (
        providerScheduleEnd &&
        startOfDay(providerScheduleEnd) <= startOfDay(date)
      ) {
        return {
          className: 'blocked-day',
          style: {
            pointerEvents: 'none ',
            backgroundColor: '#7a7e7c',
          },
        };
      }

      const dayOfWeek = date.getDay() === 0 ? 7 : date.getDay();
      const isBlocked =
        allBlockData &&
        allBlockData.some((item) => {
          return parseInt(item.day_id) === parseInt(dayOfWeek);
        });

      if (allBlockData.length > 0 && isBlocked) {
        return {
          className: 'blocked-day',
          style: {
            pointerEvents: 'none ',
            backgroundColor: '#7a7e7c',
          },
        };
      }
      return {};
    },
    [allBlockData, allData?.providerScheduleEnd, allData?.overrideSetting],
  );

  const eventPropGetter = useCallback((event) => {
    let bgColor = 'blue';
    if (event.app_status === '1') {
      bgColor = 'gray';
    } else if (event.app_status === '2') {
      bgColor = 'gray';
    } else if (event.app_status === '3') {
      bgColor = 'gray';
    } else {
      if (event.app_color) {
        bgColor = event.app_color;
      }
    }

    return {
      style: {
        color: 'black',
        backgroundColor: bgColor,
        pointerEvents: 'auto',
        // zIndex: 1,
      },
    };
  }, []);

  const slotPropGetter = useCallback(
    (date) => {
      const hour = date.getHours();
      const minute = date.getMinutes();

      const fbsh = new Date(allData?.firstBreakStart).getHours();
      const fbsm = new Date(allData?.firstBreakStart).getMinutes();

      const fbeh = new Date(allData?.firstBreakEnd).getHours();
      const fbem = new Date(allData?.firstBreakEnd).getMinutes();

      const sbsh = new Date(allData?.secondBreakStart).getHours();
      const sbsm = new Date(allData?.secondBreakStart).getMinutes();

      const sbeh = new Date(allData?.secondBreakEnd).getHours();
      const sbem = new Date(allData?.secondBreakEnd).getMinutes();

      const isAvailableInIntervals =
        allData?.openMyCalander?.some((interval) => {
          const start = parseISO(interval.start_time);
          const end = parseISO(interval.end_time);

          // Ensure a valid interval (start must be before end)
          if (compareAsc(start, end) >= 0) return false;

          return isWithinInterval(date, { start, end });
        }) || false;

      return {
        ...(allData?.startHour &&
          calPeriodFilter.name === 'day' &&
          (date.getHours() < new Date(allData?.startHour).getHours() ||
            (date.getHours() === new Date(allData?.startHour).getHours() &&
              date.getMinutes() <
                new Date(allData?.startHour).getMinutes())) && {
            style: {
              backgroundColor: 'gray',
              color: 'white',
            },
          }),
        ...(allData?.lastHour &&
          calPeriodFilter.name === 'day' &&
          (date.getHours() > new Date(allData?.lastHour).getHours() ||
            (date.getHours() === new Date(allData?.lastHour).getHours() &&
              date.getMinutes() >=
                new Date(allData?.lastHour).getMinutes())) && {
            style: {
              backgroundColor: 'gray',
              color: 'white',
            },
          }),
        ...(calPeriodFilter.name === 'day' &&
          (hour > fbsh || (hour === fbsh && minute >= fbsm)) &&
          (hour < fbeh || (hour === fbeh && minute < fbem)) && {
            style: {
              backgroundColor: '#d1d1d1',
              color: 'black',
            },
          }),
        ...(calPeriodFilter.name === 'day' &&
          (hour > sbsh || (hour === sbsh && minute >= sbsm)) &&
          (hour < sbeh || (hour === sbeh && minute < sbem)) && {
            style: {
              backgroundColor: '#d1d1d1',
              color: 'black',
            },
          }),
        ...(isAvailableInIntervals && {
          style: {
            // These styles will be applied if isAvailable is false
            pointerEvents: 'auto',
            backgroundColor: '#fff', // Added a default color here for clarity
            color: 'black',
          },
        }),
      };
    },
    [
      allData?.startHour,
      allData?.lastHour,
      allData?.firstBreakStart,
      allData?.firstBreakEnd,
      calPeriodFilter.name,
      allData?.secondBreakEnd,
      allData?.secondBreakStart,
      allData?.openMyCalander,
    ],
  );

  let filteredEvent = [];

  if (allData?.events && allData.events.length > 0) {
    filteredEvent = allData.events.filter((event) => {
      if (cancelCheck && !rescheduleCheck) {
        // For all events including cancel events and excluding reschedule events
        return event.appData?.status !== 'Rescheduled';
      } else if (!cancelCheck && rescheduleCheck) {
        // For all events including reschedule events and excluding cancel events
        return event.appData?.status !== 'Canceled';
      } else if (cancelCheck && rescheduleCheck) {
        // For all events including both cancel and reschedule events
        return event;
        // event.appData?.status === 'Canceled' ||
        // event.appData?.status === 'Rescheduled'
      } else {
        // For all events except cancel and reschedule events
        return (
          event.appData?.status !== 'Canceled' &&
          event.appData?.status !== 'Rescheduled'
        );
      }
    });
  }

  return (
    <div>
      {selectedEvent && <TitlePpup />}
      <div style={{ display: 'flex', margin: '10px', alignItems: 'center ' }}>
        <CalanderHeader
          locList={locList}
          handleLocation={handleLocation}
          selectedVal={appSearchPrams.clinicLocation}
        />
        <select
          className="appt-col-slct"
          value={appSearchPrams.allProviders}
          onChange={handleResource}
          style={{ width: '150px', marginLeft: '10px' }}
        >
          <option value="">All</option>
          {allResource &&
            allResource.map((note, idx) => {
              return (
                <option key={idx} value={note?.id}>
                  {note?.resName}
                </option>
              );
            })}
        </select>
        {calPeriodFilter?.name === 'day' && (
          <>
            <span className="clear-left10" style={{ width: '50px' }}>
              <ReactDatePicker
                selected={new Date(calPeriodFilter?.startDate)}
                onChange={(date) => handleChange(date)}
                customInput={
                  <img
                    src={'./images/calendar-icon.png'}
                    alt="Calendar"
                    width={'30px'}
                  />
                } // Use the image as the custom input
                dateFormat={DEFAULT_DATE_FORMATE}
                popperContainer={(popperProps) => (
                  <div style={{ position: 'relative', zIndex: 9999 }}>
                    {popperProps.children}
                  </div>
                )}
              />
            </span>
            {format(new Date(calPeriodFilter?.startDate), DEFAULT_DATE_FORMATE)}
            {calPeriodFilter.name === 'day' && (
              <span className="rbc-toolbar-labels clear-left">{`Provider timing:  ${allData?.providerOfficeTime}`}</span>
            )}
          </>
        )}
        <span
          className="actn-yes center"
          onClick={() => setAddTask(true)}
          style={{ width: '100px' }}
        >
          Add Task
        </span>
        {addTask && (
          <AddTaskPopup
            key={Math.random()}
            handleClose={() => {
              setAddTask(false);
              setEventData(null);
            }}
            handleReload={() => setReload(!reload)}
            eventData={eventData?.appData}
            fromCalFlag={true}
          />
        )}
        <span
          className="actn-yes center"
          style={{ width: '140px' }}
          onClick={() => setWeeklySchedule(true)}
        >
          Weekly schedule
        </span>
        <div className="right clear-left">
          <span>
            <span className="value">
              <input
                type="checkbox"
                className="clear-top5"
                onChange={() => setCancelCheck(!cancelCheck)}
                value={cancelCheck}
                checked={cancelCheck}
              />
            </span>
          </span>
          <span className="label clear-left5 clear-right ">
            View Canceled Appt.
          </span>
          <span>
            <span className="value clear-left">
              <input
                type="checkbox"
                className="clear-top5"
                onChange={() => setRescheduleCheck(!rescheduleCheck)}
                value={rescheduleCheck}
                checked={rescheduleCheck}
              />
            </span>
          </span>
          <span className="label clear-left5">View Reschedule Appt.</span>
        </div>
      </div>

      {filteredEvent && (
        <Calendar
          key={allData?.events}
          localizer={localizer}
          {...(defaultTimeFormat?.withoutSecond === 'HH:mm' && {
            formats: {
              timeGutterFormat: 'HH:mm', // 24hr time format
              eventTimeRangeFormat: ({ start, end }) =>
                `${start.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false, // 24hr format
                })} - ${end.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false, // 24hr format
                })}`,
            },
          })}
          defaultView={calPeriodFilter.name || 'week'}
          events={filteredEvent}
          startAccessor={(event) => {
            return new Date(event.start);
          }}
          defaultDate={new Date(calPeriodFilter?.startDate) || new Date()}
          endAccessor={(event) => {
            return new Date(event.end);
          }}
          style={{ height: 500, margin: '20px 10px' }}
          titleAccessor={(event) => {
            let title = event.title;
            if (event.app_status === '1') {
              title = 'No Show';
            } else if (event.app_status === '2') {
              title = 'Canceled';
            } else if (event.app_status === '3') {
              title = 'Rescheduled';
            }
            return title;
          }}
          onRangeChange={onRangeChange}
          views={['month', 'week', 'day']}
          selectable={true}
          onSelectSlot={handleSelectSlot}
          eventPropGetter={eventPropGetter}
          onDoubleClickEvent={onDoubleClickEvent}
          onSelectEvent={onSelectEvent}
          onNavigate={onNavigate}
          dayPropGetter={dayPropGetter}
          slotPropGetter={slotPropGetter}
          min={calTime?.startTime ? new Date(calTime?.startTime) : undefined} // Set the minimum time
          max={calTime?.endTime ? new Date(calTime?.endTime) : undefined} // Set the maximum time
          toolbar={true}
          step={facilitySetting?.calander_default_slot || 15}
          scrollToTime={
            calTime?.scrliiTime ? new Date(calTime?.scrliiTime) : null
          }
        />
      )}

      {weeklySchedule && (
        <WeeklySchedule
          handleClose={() => setWeeklySchedule(false)}
          reload={() => setReload(!reload)}
        />
      )}
      {isDialogOpen && (
        <AlertDialog
          successDialog={() => closeDialog()}
          title={'Alert'}
          bodytext={'Patient is already checked in.'}
        />
      )}
    </div>
  );
}

export default BigCalander;
